import React, { useState } from "react";

import SEModal from "src/shared/components/SEModal";

import * as S from "./styled";

const NoOpenHousesModal = () => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <SEModal
      dialogStyles={{ top: "64px" }}
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
    >
      <S.ModalWrapper isOpen={isOpen} onToggle={setIsOpen}>
        <S.ModalIcon />
        <S.ModalText>No upcoming open houses</S.ModalText>
        <S.ModalButton onClick={() => setIsOpen(false)}>OK</S.ModalButton>
      </S.ModalWrapper>
    </SEModal>
  );
};

export default NoOpenHousesModal;
